import { createGlobalStyle } from "styled-components";

import "@blueprintjs/core/lib/css/blueprint.css";
import { systemFontFamily } from "common/BaseTheme";
import { browserIsSafari } from "lib/browser-detect";
import { css } from "webapp/styled-components";

// Add link underline, filter by css selector
// Filter out player
const GlobalStyle = createGlobalStyle`
    html {
        box-sizing: border-box;
        -ms-overflow-style: -ms-autohiding-scrollbar;
    }

    *, 
    *::after, 
    *::before {
        outline: none !important;
        margin: 0;
        padding: 0;
        box-sizing: inherit;
    }

    html body {
        font-weight: normal;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.9);
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        -moz-osx-font-smoothing: grayscale;
        font-family: ${systemFontFamily};
        padding: 0 !important;
    }

    #root {
        position: relative;
        /* FIX this type issue */
        background-color: ${p => (p.theme as any).bgColorAlt};
    }

    a {
        text-decoration: none !important;
        color: inherit;
    }

    input {
        appearance: none;
        border: none;
        background: none;
        font: inherit;
    }

    button {
        appearance: none;
        border: none;
        background: none;
        font: inherit;
        color: inherit;
    }

    /* Override Google Picker modal styles */
    .picker-dialog-bg {
        background-color: transparent !important;
    }

    #portal {
        > * {
            pointer-events: auto;
        }
        pointer-events: none;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: ${Math.pow(10, 7)}

    }

    .scrollbar-hide {
        /* Firefox */
            scrollbar-width: none;

        /* Safari and Chrome */
        &::-webkit-scrollbar {
            display: none;
        }
    }

    .glide-toast {
        background-color: #00C453;
        color: white;
        font-size: 13px;
        padding: 8px 2px;
        font-weight: 500;
        border-radius: 10px;
        box-shadow: 0px 0px 1px rgba(62, 65, 86, 0.25), 0px 20px 48px rgba(62, 65, 86, 0.2);
    }

    ${
        browserIsSafari
            ? ""
            : css`
                  .dvn-scroller.dvn-scroller.dvn-scroller {
                      color: rgba(0, 0, 0, 0);

                      overflow: auto;
                      overflow: overlay;

                      transition: color 0.15s;
                      transition-delay: 0.2s;

                      :hover {
                          color: rgba(0, 0, 0, 0.3);
                      }

                      ::-webkit-scrollbar {
                          width: 10px;
                          height: 10px;
                      }

                      ::-webkit-scrollbar-track {
                          background: transparent;
                      }

                      ::-webkit-scrollbar-thumb {
                          border: solid 2px transparent;
                          box-shadow: inset 0 0 10px 10px;
                          border-radius: 100px;
                          margin: 2px;

                          :hover {
                              box-shadow: inset 0 0 10px 10px rgba(0, 0, 0, 0.5) !important;
                          }
                      }
                  }
              `
    }
`;

export default GlobalStyle;
